import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/BookmarksPage.css';
import allowedUsers from '../data/usersallowed.json';

const BookmarksPage = () => {
  const [email, setEmail] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);
  const navigate = useNavigate();

  // Check if email is valid yahoo.com domain
  const isValidDomain = email.endsWith('@yahoo.com') && email.length > 10;

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    
    // Check if email ends with @yahoo.com
    if (!email.endsWith('@yahoo.com')) {
      setAccessDenied(true);
      return;
    }

    // Check if email is in allowed list
    if (allowedUsers.includes(email)) {
      // Store email in sessionStorage
      sessionStorage.setItem('bookmarksAuthEmail', email);
      
      // Navigate to bookmarks view page
      navigate('/bookmarks-view');
    } else {
      setAccessDenied(true);
    }
  };

  // Email verification screen
  return (
    <div className="bookmarks-auth-container">
      {!accessDenied ? (
        <div className="bookmarks-auth-card">
          <h2 className="bookmarks-auth-title">🔐 Access Bookmarks</h2>
          <form onSubmit={handleEmailSubmit} className="bookmarks-auth-form-inline">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@yahoo.com"
              className="bookmarks-auth-input"
              required
              autoFocus
            />
            <button 
              type="submit" 
              className="bookmarks-auth-button"
              disabled={!isValidDomain}
            >
              Access
            </button>
          </form>
          <p className="bookmarks-auth-note">
            ℹ️ Only @yahoo.com email addresses are allowed
          </p>
        </div>
      ) : (
        <div className="bookmarks-access-denied">
          <div className="access-denied-icon">🚫 Access Denied</div>
          {/* <h2 className="access-denied-title">Access Denied</h2> */}
          <p className="access-denied-message">
            {!email.endsWith('@yahoo.com') 
              ? 'Only @yahoo.com email addresses are allowed.' 
              : 'Your email is not authorized to access this content.'}
          </p>
          <p className="access-denied-email">
            Email entered: <strong>{email}</strong>
          </p>
          <button 
            className="access-denied-retry"
            onClick={() => {
              setAccessDenied(false);
              setEmail('');
            }}
          >
            Try Again
          </button>
        </div>
      )}
    </div>
  );
};

export default BookmarksPage;
